var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShoppingCart10903(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 76.675 62.176 H 24.794 c -1.409 0 -2.628 -0.98 -2.93 -2.356 l -8.222 -37.465 c -0.195 -0.887 0.023 -1.815 0.592 -2.523 c 0.57 -0.708 1.429 -1.12 2.338 -1.12 H 87 c 0.853 0 1.665 0.363 2.234 0.998 c 0.568 0.635 0.841 1.482 0.748 2.33 l -3.434 31.287 C 85.995 58.371 81.75 62.176 76.675 62.176 z M 27.207 56.176 h 49.468 c 2.01 0 3.69 -1.507 3.909 -3.505 l 3.068 -27.96 H 20.302 L 27.207 56.176 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 53.842 62.176 c -1.657 0 -3 -1.343 -3 -3 V 21.711 c 0 -1.657 1.343 -3 3 -3 s 3 1.343 3 3 v 37.465 C 56.842 60.833 55.499 62.176 53.842 62.176 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 68.233 62.176 c -0.082 0 -0.165 -0.003 -0.249 -0.01 c -1.651 -0.137 -2.88 -1.585 -2.744 -3.236 l 3.083 -37.465 c 0.136 -1.65 1.568 -2.882 3.236 -2.744 c 1.651 0.136 2.88 1.584 2.744 3.236 l -3.083 37.465 C 71.092 60.989 69.779 62.176 68.233 62.176 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 39.448 62.176 c -1.51 0 -2.81 -1.137 -2.978 -2.673 l -4.111 -37.465 c -0.181 -1.647 1.008 -3.128 2.655 -3.309 c 1.647 -0.18 3.128 1.008 3.309 2.655 l 4.111 37.465 c 0.181 1.646 -1.008 3.129 -2.655 3.31 C 39.668 62.17 39.558 62.176 39.448 62.176 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 84.944 43.443 H 20.683 c -1.657 0 -3 -1.343 -3 -3 s 1.343 -3 3 -3 h 64.262 c 1.657 0 3 1.343 3 3 S 86.602 43.443 84.944 43.443 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.47,
    cy: 73.28,
    r: 7,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 73.28,
    r: 7,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 29.539 73.691 h -3.098 c -4.83 0 -8.758 -3.929 -8.758 -8.758 s 3.929 -8.758 8.758 -8.758 c 1.657 0 3 1.343 3 3 s -1.343 3 -3 3 c -1.521 0 -2.758 1.237 -2.758 2.758 s 1.237 2.758 2.758 2.758 h 3.098 c 1.657 0 3 1.343 3 3 S 31.195 73.691 29.539 73.691 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 67.575 73.691 H 39.452 c -1.657 0 -3 -1.343 -3 -3 s 1.343 -3 3 -3 h 28.123 c 1.657 0 3 1.343 3 3 S 69.232 73.691 67.575 73.691 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 81.383 73.691 h -3.305 c -1.657 0 -3 -1.343 -3 -3 s 1.343 -3 3 -3 h 3.305 c 1.657 0 3 1.343 3 3 S 83.04 73.691 81.383 73.691 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 16.569 24.711 c -1.378 0 -2.62 -0.956 -2.927 -2.357 l -0.554 -2.522 c -0.724 -3.296 -3.698 -5.689 -7.072 -5.689 H 3 c -1.657 0 -3 -1.343 -3 -3 s 1.343 -3 3 -3 h 3.016 c 6.171 0 11.61 4.375 12.933 10.402 l 0.554 2.521 c 0.355 1.619 -0.668 3.218 -2.287 3.574 C 16.999 24.689 16.782 24.711 16.569 24.711 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart10903);
export default __webpack_public_path__ + "static/media/shopping-cart-10903.f75efce858f393577c7fdac278589ed3.svg";
export { ForwardRef as ReactComponent };